import React from "react";
import moment from "moment";
import Moment from "react-moment";
import { ActivityInputValue } from "../../models";
import { ActivityLog } from "../../models";
import { DatePicker } from "@fluentui/react";
import { FontIcon } from "@fluentui/react";
import { MaskedTextField } from "@fluentui/react";
import { mergeStyleSets } from "@fluentui/react";
import { useEffect } from "react";
import { useState } from "react";

const classes = mergeStyleSets({
  inputField: {
    fontSize: "22px !important",
    textAlign: "left"
  },
  inputValue: {
    display: "flex",
    justifyContent: "space-between",
    border: "1px solid #E2E6E8",
    backgroundColor: "#FAFAFA",
    padding: 6,
    marginBottom: 4
  },
  inputValueText: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "space-between",
    border: "1px solid #E2E6E8",
    backgroundColor: "#FAFAFA",
    padding: 6,
    marginBottom: 4,
    selectors: {
      ["b"]: {
        wordWrap: "break-word",
        width: "100%",
        textAlign: "start"
      }
    }
  }
});

const EditTimestampItem = (props: {
  activityLog: ActivityLog;
  disabled: boolean;
  onChange(activityId: number, value: Date): string | null;
}) => {
  const { activityLog, disabled } = props;
  const [statusLabel, setStatusLabel] = useState("");
  const [timeValue, setTimeValue] = useState<string>();
  const [errorMessage, setErrorMessage] = useState<string>();
  const [dateValue, setDateValue] = useState<Date>();
  const [inputValues, setInputValues] = useState<ActivityInputValue[]>([]);

  const onSelectDate = (date: Date | null | undefined) => {
    setErrorMessage(undefined);

    if (date && timeValue) {
      setDateValue(date);
      const vals = timeValue.split(":");
      const hour = parseInt(vals[0], 10);
      const minute = parseInt(vals[1], 10);
      date.setHours(hour);
      date.setMinutes(minute);
      date.setSeconds(59);

      if (date > new Date()) {
        setErrorMessage("Timestamp must not be in the future.");
        return;
      }

      props.onChange(activityLog.id, date);
    }
  };

  const onTimeChange = (e: any, value?: string) => {
    setErrorMessage(undefined);
    setTimeValue(value);

    if (value && dateValue) {
      const vals = value.split(":");
      const hour = parseInt(vals[0], 10);
      const minute = parseInt(vals[1], 10);
      if (isNaN(hour) || isNaN(minute)) {
        setErrorMessage("Invalid timestamp value.");
        return;
      }
      dateValue.setHours(hour);
      dateValue.setMinutes(minute);
      dateValue.setSeconds(59);

      const result = props.onChange(activityLog.id, dateValue);
      if (result) {
        setErrorMessage(result);
      }
    }
  };

  useEffect(() => {
    const logTime = moment
      .utc(activityLog.logTime)
      .format("YYYY-MM-DD HH:mm:ss");
    const local = moment.utc(`${logTime} UTC`).local();
    setDateValue(local.toDate());
    setTimeValue(local.format("HH:mm"));
    setInputValues(
      activityLog.inputValues
        ? activityLog.inputValues.filter((f) => f.caption !== "Surveyor")
        : []
    );

    let status = "";
    if (activityLog.status === 1) {
      if (
        activityLog.changes &&
        activityLog.changes.toLowerCase().indexOf("paused") >= 0
      ) {
        status = "Resume";
      } else {
        status = "Start";
      }
    } else if (activityLog.status === 2) {
      status = "End";
    } else if (activityLog.status === 5) {
      status = "Pause";
    }
    setStatusLabel(status);
  }, [activityLog]);

  return (
    <>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm8">
          <DatePicker
            label={`${statusLabel} Date`}
            className={classes.inputField}
            formatDate={(val?: Date) => (val ? moment(val).format("ll") : "")}
            onSelectDate={onSelectDate}
            disabled={disabled}
            value={dateValue}
            maxDate={new Date()}
          />
        </div>
        <div className="ms-Grid-col ms-sm4">
          <MaskedTextField
            label={`${statusLabel} Time`}
            className={classes.inputField}
            mask="12:32"
            maskFormat={{
              "1": /[0-2]/,
              "2": /[0-9]/,
              "3": /[0-5]/
            }}
            disabled={props.disabled}
            onChange={onTimeChange}
            value={timeValue}
            errorMessage={errorMessage}
          />
        </div>
      </div>
      {activityLog.performedByName && (
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm8"></div>
          <div
            className="ms-Grid-col ms-sm4"
            style={{
              fontSize: "14px",
              textAlign: "left",
              fontWeight: 600,
              paddingTop: "5px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
          >
            <FontIcon iconName="TemporaryUser" />
            &nbsp;
            {activityLog.performedByName}
          </div>
        </div>
      )}

      {inputValues && (
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            {inputValues.map((val, i) => (
              <div
                key={`activity_input_val_${i}`}
                className={
                  val.type === "number"
                    ? classes.inputValue
                    : classes.inputValueText
                }
              >
                <span>{val.caption}</span>
                {(val.type === "text" || val.type === "number") && (
                  <b>{val.value}</b>
                )}
                {val.type === "signature" && (
                  <img src={val.value} alt="Signature" />
                )}
                {val.type === "datetime" && (
                  <b>
                    <Moment format="ll HH:mm" local>
                      {val.value}
                    </Moment>
                  </b>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="ms-Grid-row">
        <div style={{ height: 12 }}></div>
      </div>
    </>
  );
};
export default EditTimestampItem;
